import React from 'react';
import { PayButtonView } from './view';

interface PayButtonControllerProps {
  text?: string;
  isDisabled?: boolean;

  onLoadingChanged?(key: string, status: boolean): void;
  pay(): Promise<any>;
}

interface PayButtonControllerState {
  isLoading: boolean;
  isDisabled: boolean;
}

export class PayButtonController extends React.Component<
  PayButtonControllerProps,
  PayButtonControllerState
> {
  private isComponentMounted: boolean = false;

  state = {
    isLoading: false,
    isDisabled: false,
  };

  componentDidMount() {
    this.isComponentMounted = true;
  }

  componentDidUpdate(
    prevProps: PayButtonControllerProps,
    prevState: PayButtonControllerState
  ) {
    if (prevState.isLoading !== this.state.isLoading) {
      this.props.onLoadingChanged?.('PayButton', this.state.isLoading);
    }
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  handlePay = async () => {
    this.setState({
      isLoading: true,
      isDisabled: true,
    });

    try {
      await this.props.pay();
    } catch (e) {
      console.error(`Failed to pay`, e);
    }

    if (this.isComponentMounted) {
      this.setState({
        isLoading: false,
        isDisabled: false,
      });
    }
  };

  render() {
    return (
      <PayButtonView
        text={this.props.text}
        isLoading={this.state.isLoading}
        isDisabled={this.state.isDisabled || this.props.isDisabled}
        onClick={this.handlePay}
      />
    );
  }
}
